import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "../lib/navigation";

/** Scroll to location.hash after navigation (and on first mount). */
export function useHashScroll(): void {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scrollToHash("smooth");
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location.pathname, location.hash, location.key]);
}
